<div class="main-result">
  <section class="flightSearchSectionInnner">
    <app-global-breadcrumbs class="d-none"></app-global-breadcrumbs>
    <app-flight-inner-header></app-flight-inner-header>
  </section>
  <div class="container">
    <app-one-way *ngIf="oneWayTrip"></app-one-way>
    <app-round-way *ngIf="roundWayTrip"></app-round-way>
    <app-round-way-international *ngIf="internationRoundTrip"></app-round-way-international>
  </div>
  <div class="topButton">
    <button mat-button mat-fab (click)="scrollToTop()" color="primary">
      <mat-icon>arrow_upward</mat-icon>
    </button>
  </div>
</div>
